import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function OUTA
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={42}
            adderFlag={22}
            labelBlock={'OUTA'}
            showLabelInput={true}
            userConfiguration={true}
        />
    );
}
export default OUTA